import React, { FC, useEffect } from 'react';
import { Audience, SecureRoute, useAuthState } from '@vis-auth/react';
import { EveRoutes } from '@ver-uds/e-verify';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
import ReactGA from 'react-ga4';
import { ErrorPage } from './pages';
import ClientSignMouPage from './pages/ClientMou/ClientSignMouPage';
import ClientMouResultPage, { MouSignType } from './pages/ClientMou/ClientMouResultPage';
import ClientMouWrapper from './components/ClientMou/ClientMouWrapper';
import { MouRoutes } from './components/ClientMou/constants';

const OriginRedirect = ({ path }: { path: string }): null => {
  useEffect(() => {
    window.location.assign(path);
  });
  return null;
};

const MouRoute: FC = () => {
  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });
  }, []);

  const { audience } = useAuthState();

  const isDashboardJWT = audience === Audience.everifyEmail;
  const isEnrollmentJWT = audience === Audience.everifyEnrollment;

  if (isDashboardJWT) {
    return (
      <SecureRoute path="/">
        <OriginRedirect path={EveRoutes.DASHBOARD} />
      </SecureRoute>
    );
  }

  if (isEnrollmentJWT) {
    return (
      <SecureRoute path="/">
        <OriginRedirect path={EveRoutes.ACCOUNT_ENROLL} />
      </SecureRoute>
    );
  }

  return (
    <>
      <Route path={MouRoutes.BASE}>
        <ErrorBoundary
          FallbackComponent={() => (
            <>
              <ClientMouWrapper title="System Error" hideSkipNav>
                <ErrorPage />
              </ClientMouWrapper>
            </>
          )}
        >
          <Switch>
            <Route exact path={MouRoutes.SIGN} render={() => <ClientSignMouPage />} />
            <Route
              exact
              path={MouRoutes.ACCEPT}
              render={() => <ClientMouResultPage mouSignType={MouSignType.SIGNED} />}
            />
            <Route
              exact
              path={MouRoutes.REJECT}
              render={() => <ClientMouResultPage mouSignType={MouSignType.REJECTED} />}
            />
            <Route path="*" render={() => <Redirect to="/error" />} />
          </Switch>
        </ErrorBoundary>
      </Route>
    </>
  );
};

export default MouRoute;
